/**
 *
 * 人寿保险合作
 *
 */
import { getUrlParam, getUserInfo } from '@/utils/api';

const comein_channel = 'rmbx';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function Bridge() {
	this.comein_channel = comein_channel;

	this.comein_channel_pc = comein_channel;

	this.favicon = 'https://image.comein.cn/web/roadshow/thirdparty/rmbxlogo.png';

	this.isVistor = true;

	this.uc = '';

	this.showMenu = false;

	// 直播厅没有聊天互动
	this.room_no_chat = true;

	this.tabList = [
		{
			title: '详情',
			type: 'detail',
			index: 0,
			num: undefined
		},
		{
			title: '文档',
			type: 'docs',
			index: 2,
			num: undefined
		}
	];
}

Bridge.prototype.joinEventFail = function (code = 201, ctx) {
	if (code == 201 && ctx) {
		ctx.dispatch('showDialog', {
			dialog_affirm: true,
			dialog_text: '提交参会信息后，即可进入会议',
			dialog_confirm_btn: () => {
				this.$router.push({ name: 'roadshow_vistor', query: { comein_channel } });
			}
		});
	} else {
		this.showTooltip(this.$t('您暂无观看权限'));
	}
};

Bridge.prototype.checkLogin = function () {
	const userInfo = getUserInfo();

	if (!(userInfo && userInfo.comein_channel === comein_channel)) {
		this.$router.push({ name: 'roadshow_vistor', query: { comein_channel } });
		return false;
	}

	return true;
};

export default Bridge;
